const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://fae8xvqm8h.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://36zx4ciw36.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.staging.pas.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.pas.forwoodsafety.com',
    WEBSOCKET: 'wss://ko2233x0k2.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;